import React, { ReactNode, useContext, useMemo } from 'react';
import {
  BrukerApi,
  BrukerApiInterface,
  PraksisApi,
  PraksisApiInterface,
  PraksisstedApi,
  PraksisstedApiInterface,
} from './generated/student-generated-api';
import { SessionContext } from './sessionExtension';

export interface StudentApiStore {
  brukerApi: BrukerApiInterface;
  praksisApi: PraksisApiInterface;
  praksisstedApi: PraksisstedApiInterface;
}

export const StudentApiContext = React.createContext<StudentApiStore>({
  brukerApi: new BrukerApi(() => {}),
  praksisApi: new PraksisApi(() => {}),
  praksisstedApi: new PraksisstedApi(() => {}),
});

export const StudentApiProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const { setKeepAlive } = useContext(SessionContext);

  const studentApiStore: StudentApiStore = useMemo(
    () => ({
      brukerApi: new BrukerApi(setKeepAlive),
      praksisApi: new PraksisApi(setKeepAlive),
      praksisstedApi: new PraksisstedApi(setKeepAlive),
    }),
    [setKeepAlive],
  );

  return (
    <StudentApiContext.Provider value={studentApiStore}>
      {children}
    </StudentApiContext.Provider>
  );
};
